import React, { useEffect } from 'react';
import { Form, Input, Button, InputNumber, Divider } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { resetApiStatus } from 'redux/reducers/globals/globalActions';
import { postApi } from 'redux/sagas/postApiDataSaga';

const buildOrgPayload = (values) => {
	const {
		addressLine1,
		addressLine2,
		city,
		pincode,
		state,
		country,
		contact,
		...rest
	} = values;

	return {
		...rest,
		addressDetails: {
			addressLine1: addressLine1 || '',
			addressLine2: addressLine2 || '',
			city: city || '',
			pincode: pincode ?? null,
			state: state || '',
			country: country || 'India',
			contact: contact || '',
		},
	};
};

const OrgAddressFields = () => (
	<>
		<Divider>Organization Address</Divider>
		<Form.Item label="Address Line 1" name="addressLine1">
			<Input />
		</Form.Item>
		<Form.Item label="Address Line 2" name="addressLine2">
			<Input />
		</Form.Item>
		<Form.Item label="City" name="city">
			<Input />
		</Form.Item>
		<Form.Item label="Pincode" name="pincode">
			<InputNumber style={{ width: '100%' }} />
		</Form.Item>
		<Form.Item label="State" name="state">
			<Input />
		</Form.Item>
		<Form.Item label="Country" name="country" initialValue="India">
			<Input />
		</Form.Item>
		<Form.Item label="Contact" name="contact">
			<Input />
		</Form.Item>
	</>
);

const AddOrganization = ({ refreshList, closeModal }) => {
	const globalRedux = useSelector((state) => state.globalRedux);
	const dispatch = useDispatch();
	const [addFormInstance] = Form.useForm();

	const FormCol = {
		labelCol: {
			span: 12,
		},
		wrapperCol: {
			span: 24,
		},
	};

	const onSubmit = (values) => {
		dispatch(postApi(buildOrgPayload(values), 'ADD_ORGANIZATION'));
	};

	useEffect(() => {
		if (globalRedux.apiStatus.ADD_ORGANIZATION === 'SUCCESS') {
			addFormInstance.resetFields();
			refreshList();
			dispatch(resetApiStatus('ADD_ORGANIZATION'));
		}
	}, [globalRedux.apiStatus]);

	return (
		<Form
			style={{ padding: '0 20px' }}
			className="custom-form"
			requiredMark={false}
			colon={false}
			layout="vertical"
			labelAlign="left"
			form={addFormInstance}
			onFinish={onSubmit}
			{...FormCol}>
			<Form.Item
				label="Organization Name"
				name="orgName"
				rules={[
					{
						required: true,
						message: 'This Field is Required!',
					},
				]}>
				<Input />
			</Form.Item>

			<Form.Item
				label="GSTIN"
				name="gstin"
				rules={[
					{
						required: true,
						message: 'This Field is Required!',
					},
				]}>
				<Input />
			</Form.Item>

			<OrgAddressFields />

			<Form.Item
				wrapperCol={{
					offset: 0,
					span: 16,
				}}>
				<Button
					loading={globalRedux.apiStatus.ADD_ORGANIZATION === 'PENDING'}
					disabled={globalRedux.apiStatus.ADD_ORGANIZATION === 'PENDING'}
					type="primary"
					style={{ marginRight: '10px' }}
					htmlType="submit">
					Create
				</Button>

				<Button
					onClick={() => {
						closeModal();
						addFormInstance.resetFields();
					}}
					danger>
					Cancel
				</Button>
			</Form.Item>
		</Form>
	);
};

export { buildOrgPayload, OrgAddressFields };
export default AddOrganization;
